module.exports = __webpack_public_path__ + "static/media/Find_levers_7.000d30bd.png";